import { z } from 'zod';

// Create/Edit
export const AddressFormSchema = z.object({
  nameOnCard: z.string().trim().min(1, { message: 'Name is required' }),
  countryName: z.string().trim().min(1, { message: 'Country name required' }),
  countryCode: z.string().trim().min(1, { message: 'Country is required' }),
  streetAddress: z
    .string()
    .trim()
    .min(1, { message: 'Street address is required' }),
  locality: z.string().trim().min(1, { message: 'City is required' }),
  region: z.string().trim().min(1, { message: 'Region is required' }),
  regionCode: z.string().trim().min(1, { message: 'Region is required' }),
  postalCode: z.string().trim().min(1, { message: 'Postal code required' }),
});

export type AddressForm = z.infer<typeof AddressFormSchema>;

export const CardDetailsSchema = z.object({
  token: z.string().min(1, { message: 'Payment method required' }),
  isNew: z.boolean(),
});

export const NewPaymentMethodFormSchema = AddressFormSchema.extend({
  // userId: z.string(),
  // newPaymentMethodToken: z.string().min(1, 'Error in credit card information'),
  newPaymentMethodToken: z.string(),
  numberValidity: z.string().min(1, 'Please enter a valid card number'),
  expirationDateValidity: z
    .string()
    .min(1, 'Please enter a valid expiration date'),
  cvvValidity: z.string().min(1, 'Please enter a valid code'),
  // paymentMethod: CardDetailsSchema.extend({
  //   isNew: z.literal(true),
  // }),
  // savePayment: z.boolean().optional(),
});

export const EditBillingAddressFormSchema = NewPaymentMethodFormSchema.extend({
  newPaymentMethodToken: z.string().optional(),
  numberValidity: z.string(),
  expirationDateValidity: z.string(),
  cvvValidity: z.string(),
});

export type PaymentMethodForm = z.infer<typeof NewPaymentMethodFormSchema>;

interface PaymentMethodFormRequest {
  provider: string;
  billingAddress: {
    nameOnCard: string;
    countryName: string;
    streetAddress: string;
    locality: string;
    region: string;
    postalCode: string;
  };
  userId: string;
  token: string;
  default?: boolean;
}

// List
export const PaymentMethodSchema = z.object({
  _id: z.string(),
  stripeId: z.string().optional(),
  braintreeId: z.string().optional(),
  cardType: z.string(),
  // imageUrl: z.string().optional(),
  last4: z.string().optional(),
  expirationMonth: z.string().optional(),
  expirationYear: z.string().optional(),
  default: z.boolean().optional(),
  billingAddress: z.object({
    nameOnCard: z.string().optional(),
    countryName: z.string().optional(),
    streetAddress: z.string().optional(),
    locality: z.string().optional(), // city
    region: z.string().optional(), // state
    postalCode: z.coerce.string().optional(),
  }),
});

export const PaymentMethodsSchema = PaymentMethodSchema.array();

export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;

export type ListPaymentMethodsResponse = PaymentMethod[];
export type ListPaymentMethodsRequest = void;

// Create
export type CreatePaymentMethodRequest = PaymentMethodFormRequest;
export const CreatePaymentMethodResponseSchema = PaymentMethodSchema;
export type CreatePaymentMethodResponse = PaymentMethod;

// Edit
export interface UpdatePaymentMethodRequest {
  id: string;
  payload: Partial<PaymentMethodFormRequest>;
}
export const UpdatePaymentMethodResponseSchema = PaymentMethodSchema;
export type UpdatePaymentMethodResponse = PaymentMethod;

// Delete
export type DeletePaymentMethodRequest = string;
export type DeletePaymentMethodResponse = void;
export const DeletePaymentMethodResponseSchema = z.void();
